<template>
  <div>
    <Form ref="dicForm" :model="dicForm" :label-width="120">
      <FormItem label="服务名称" prop="dicNames">
        <div>
          <Checkbox
            :indeterminate="isIndeterminate"
            :value="checkAll"
            @click.prevent.native="handleCheckAllChange"
          >
            <span>全选</span>
          </Checkbox>
        </div>

        <CheckboxGroup
          v-model="dicCheckList"
          @on-change="handleCheckedDicChange"
        >
          <Checkbox
            v-for="dic in dicAllList"
            :label="dic.dictionaryCode"
            :key="dic.dictionaryCode"
          >
            <span>{{ dic.dictionaryValue }}</span>
          </Checkbox>
        </CheckboxGroup>
      </FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button
        type="success"
        @click="handleSubmit()"
        class="mr-5"
        :loading="loading"
        >确 定</Button
      >
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      dicForm: {
        ClientSN: "",
        ClientName: "",
        DicCodeList: [],
      },
      checkAll: false,
      checkedDicList: [],
      dicAllList: [],
      dicCheckList: [],
      isIndeterminate: false,
      loading: false,
    };
  },
  mounted() {
    this.getDicList();
    this.dicForm.ClientSN = this.currentData.clientSN;
    this.dicForm.ClientName = this.currentData.clientName;
  },
  methods: {
    returnBack: function () {
      this.$emit("close");
    },
    resetData() {
      this.DicCodeList = [];
      this.$refs["dicForm"].resetFields();
    },
    //获取服务列表
    getDicList() {
      var _this = this;
      this.$api
        .get("/dictionary/getDictionaryListByCategroyCode?categroyCode=9001")
        .then((rsp) => {
          if (rsp != false) {
            _this.dicAllList = rsp.data;
          }
        });
    },
    handleCheckAllChange() {
     
      if (this.isIndeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.isIndeterminate = false;
      if (this.checkAll) {
        let allChecks = [];
        this.dicAllList.forEach((item) => {
          allChecks.push(item.dictionaryCode);
        });
        this.dicCheckList = allChecks;
      } else {
        this.dicCheckList = [];
      }
    },
    handleCheckedDicChange(value) {
      
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.dicAllList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.dicAllList.length;
    },
    handleSubmit() {
      if (this.dicCheckList.length < 1) {
        this.$Message.error("请至少选择一条服务名称");
        return;
      }
      this.loading = true;
      this.dicCheckList.forEach((item) => {
        this.dicForm.DicCodeList.push(item);
      });
      this.$api.post("/clientDetail/initConfig", this.dicForm).then((rsp) => {
        if (rsp != false) {
          this.$Message.success("更新成功");
          this.returnBack();
          this.resetData();
          this.$emit("loadData");
        }
        this.dicForm.DicCodeList = [];
        this.loading = false;
      });
    },
  },
};
</script>
